// extracted by mini-css-extract-plugin
module.exports = {"placeholderIndicator":"PlaceholderIndicator_placeholderIndicator__rtN3s"};